/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { ThemeProvider } from "emotion-theming"
import styled from "@emotion/styled"
import CookieConsent from "react-cookie-consent"
import { Link } from "gatsby"

import theme from "../../utils/theme"
import Nav from "./nav/Nav"
import Footer from "./Footer"

// If there's custom fonts import here
// import "../../utils/fonts"

const Container = styled.main`
  padding-top: 104px;
`

export default function Layout({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <Nav />
      <Container>{children}</Container>
      <Footer />
      <CookieConsent
        location="bottom"
        buttonText="I Accept"
        cookieName="userfyTrackingCookie"
        style={{ background: "#3C4044" }}
        buttonStyle={{
          backgroundColor: "#0047FF",
          color: "#FFFFFF",
          borderRadius: "32px",
          padding: "12px 40px",
        }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.{" "}
        <Link style={{ color: "#FFFFFF" }} to="/cookie-policy/">
          Cookie Policy
        </Link>
      </CookieConsent>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}
